import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronLeft, Crown, CheckCircle, Clock, Download, ExternalLink, MessageSquare, AlertCircle, CreditCard, Calendar, ArrowRight } from 'lucide-react';
export function VeliAbonelikBilgileri() {
  const navigate = useNavigate();
  // Paket özellikleri
  const features = ['Tüm konu anlatım videoları', 'Sınırsız soru çözümü', 'Haftalık performans raporları', 'Deneme Sınavı Analizleri', 'Kişiselleştirilmiş çalışma programı', 'Deneme Sınavları', 'Rehberlik hizmetleri', 'Konu Takip Çizelgesi', 'Sınırsız Soru Arşivi', 'Veli takip paneli'];
  // Fatura geçmişi
  const billingHistory = [{
    id: 'INV-2023-001',
    date: '01.09.2023',
    amount: '4.999 TL',
    status: 'Ödendi'
  }, {
    id: 'INV-2022-002',
    date: '01.09.2022',
    amount: '399,99 ₺',
    status: 'Ödendi'
  }];
  return <div className="space-y-8" data-id="element-189">
      {/* Sayfa Başlığı */}
      <div className="flex items-center gap-4" data-id="element-190">
        <button onClick={() => navigate('/profil')} className="flex items-center gap-2 px-4 py-2 rounded-lg bg-gradient-to-r from-blue-600 to-blue-800 text-white hover:opacity-90 transition-colors" data-id="element-191">
          <ChevronLeft className="w-5 h-5" data-id="element-192" />
          Geri
        </button>
        <h1 className="text-2xl font-bold" data-id="element-193">Abonelik Bilgileri</h1>
      </div>
      {/* Mevcut Abonelik Kartı */}
      <div className="relative p-[1px] rounded-xl overflow-hidden bg-gradient-to-r from-blue-600 to-blue-800" data-id="element-194">
        <div className="relative p-6 bg-black/90 rounded-xl" data-id="element-195">
          <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-6" data-id="element-196">
            <div className="flex items-center gap-4" data-id="element-197">
              <div className="p-3 rounded-full bg-blue-500/20 text-blue-400" data-id="element-198">
                <Crown className="w-8 h-8" data-id="element-199" />
              </div>
              <div data-id="element-200">
                <h2 className="text-xl font-bold" data-id="element-201">LGS Premium</h2>
                <p className="text-gray-400" data-id="element-202">4.999 TL/Yıllık</p>
              </div>
            </div>
            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4" data-id="element-203">
              <div className="flex items-center gap-2 px-3 py-1.5 rounded-full bg-green-500/20 text-green-400 text-sm" data-id="element-204">
                <span className="w-2 h-2 rounded-full bg-green-400" data-id="element-205"></span>
                Aktif
              </div>
              <div className="group relative" data-id="element-206">
                <div className="flex items-center gap-2 text-gray-400 cursor-help" data-id="element-207">
                  <Clock className="w-4 h-4" data-id="element-208" />
                  <span data-id="element-209">312 gün kaldı</span>
                  <AlertCircle className="w-4 h-4" data-id="element-210" />
                </div>
                {/* Tooltip */}
                <div className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 w-60 p-3 bg-gray-900 rounded-lg shadow-lg opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 z-10" data-id="element-211">
                  <div className="text-sm text-gray-300" data-id="element-212">
                    <p className="font-medium mb-1" data-id="element-213">Abonelik bitiş tarihi:</p>
                    <p data-id="element-214">12 Ağustos 2024</p>
                  </div>
                  <div className="absolute bottom-0 left-1/2 -translate-x-1/2 translate-y-1/2 rotate-45 w-2 h-2 bg-gray-900" data-id="element-215"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Paket Özellikleri ve Fatura Geçmişi */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-216">
        {/* Sol: Paket Özellikleri */}
        <div className="relative p-[1px] rounded-xl overflow-hidden bg-gradient-to-r from-blue-600 to-blue-800" data-id="element-217">
          <div className="relative p-6 bg-black/90 rounded-xl h-full" data-id="element-218">
            <h3 className="text-lg font-bold mb-4" data-id="element-219">
              LGS Premium Paket Özellikleri
            </h3>
            <ul className="space-y-3" data-id="element-220">
              {features.map((feature, index) => <li key={index} className="flex items-start gap-3" data-id="element-221">
                  <CheckCircle className="w-5 h-5 text-green-400 shrink-0 mt-0.5" data-id="element-222" />
                  <span data-id="element-223">{feature}</span>
                </li>)}
            </ul>
          </div>
        </div>
        {/* Sağ: Fatura Geçmişi */}
        <div className="relative p-[1px] rounded-xl overflow-hidden bg-gradient-to-r from-blue-600 to-blue-800" data-id="element-224">
          <div className="relative p-6 bg-black/90 rounded-xl h-full" data-id="element-225">
            <h3 className="text-lg font-bold mb-4" data-id="element-226">Fatura Geçmişi</h3>
            <div className="space-y-3" data-id="element-227">
              {billingHistory.map(invoice => <div key={invoice.id} className="flex items-center justify-between p-3 bg-white/5 hover:bg-white/10 rounded-lg transition-colors" data-id="element-228">
                  <div className="flex items-center gap-3" data-id="element-229">
                    <div className="p-2 rounded-full bg-blue-500/20" data-id="element-230">
                      <CreditCard className="w-4 h-4 text-blue-400" data-id="element-231" />
                    </div>
                    <div data-id="element-232">
                      <p className="font-medium" data-id="element-233">{invoice.id}</p>
                      <div className="flex items-center gap-2 text-sm text-gray-400" data-id="element-234">
                        <Calendar className="w-3.5 h-3.5" data-id="element-235" />
                        <span data-id="element-236">{invoice.date}</span>
                      </div>
                    </div>
                  </div>
                  <div className="flex items-center gap-4" data-id="element-237">
                    <span className="font-medium" data-id="element-238">{invoice.amount}</span>
                    <div className="flex items-center gap-1 px-2 py-1 rounded-full bg-green-500/20 text-green-400 text-xs" data-id="element-239">
                      <span className="w-1.5 h-1.5 rounded-full bg-green-400" data-id="element-240"></span>
                      {invoice.status}
                    </div>
                    <button className="p-1.5 rounded-full bg-white/5 hover:bg-white/10 transition-colors" data-id="element-241">
                      <Download className="w-4 h-4 text-gray-400" data-id="element-242" />
                    </button>
                  </div>
                </div>)}
            </div>
          </div>
        </div>
      </div>
      {/* Yükseltme Seçenekleri */}
      <div className="relative p-[1px] rounded-xl overflow-hidden bg-gradient-to-r from-yellow-500 to-amber-500" data-id="element-243">
        <div className="relative p-6 bg-black/90 rounded-xl" data-id="element-244">
          <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-6" data-id="element-245">
            <div className="flex items-center gap-4" data-id="element-246">
              <div className="p-3 rounded-full bg-yellow-500/20 text-yellow-400" data-id="element-247">
                <Crown className="w-8 h-8" data-id="element-248" />
              </div>
              <div data-id="element-249">
                <h2 className="text-xl font-bold" data-id="element-250">LGS Premium Plus</h2>
                <p className="text-gray-400" data-id="element-251">9.999 TL/Yıllık</p>
              </div>
            </div>
            <div data-id="element-252">
              <a href="https://www.egitimpilotu.com/premium-plus" target="_blank" rel="noopener noreferrer" className="px-6 py-3 bg-gradient-to-r from-yellow-500 to-amber-500 rounded-lg hover:opacity-90 transition-opacity font-medium flex items-center gap-2" data-id="element-253">
                Paketi Yükselt
                <ExternalLink className="w-4 h-4" data-id="element-254" />
              </a>
            </div>
          </div>
          <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4" data-id="element-255">
            <div className="flex items-center gap-3 p-3 bg-white/5 rounded-lg" data-id="element-256">
              <div className="p-2 rounded-full bg-yellow-500/20" data-id="element-257">
                <CheckCircle className="w-4 h-4 text-yellow-400" data-id="element-258" />
              </div>
              <span className="text-sm" data-id="element-259">Birebir Öğretmen Desteği</span>
            </div>
            <div className="flex items-center gap-3 p-3 bg-white/5 rounded-lg" data-id="element-260">
              <div className="p-2 rounded-full bg-yellow-500/20" data-id="element-261">
                <CheckCircle className="w-4 h-4 text-yellow-400" data-id="element-262" />
              </div>
              <span className="text-sm" data-id="element-263">Aylık Gelişim Raporu</span>
            </div>
            <div className="flex items-center gap-3 p-3 bg-white/5 rounded-lg" data-id="element-264">
              <div className="p-2 rounded-full bg-yellow-500/20" data-id="element-265">
                <CheckCircle className="w-4 h-4 text-yellow-400" data-id="element-266" />
              </div>
              <span className="text-sm" data-id="element-267">VIP Soru Çözüm Desteği</span>
            </div>
          </div>
          <div className="mt-4 flex justify-end" data-id="element-268">
            <button className="flex items-center gap-1 text-yellow-400 text-sm" data-id="element-269">
              Tüm özellikleri gör
              <ArrowRight className="w-4 h-4" data-id="element-270" />
            </button>
          </div>
        </div>
      </div>
      {/* Destek Bölümü */}
      <div className="relative p-[1px] rounded-xl overflow-hidden bg-gradient-to-r from-blue-600 to-blue-800" data-id="element-271">
        <div className="relative p-6 bg-black/90 rounded-xl" data-id="element-272">
          <div className="flex flex-col md:flex-row items-center justify-between gap-6" data-id="element-273">
            <div data-id="element-274">
              <h3 className="text-lg font-bold" data-id="element-275">Yardıma mı ihtiyacınız var?</h3>
              <p className="text-gray-400 mt-2" data-id="element-276">
                Aboneliğinizle ilgili sorularınız için destek ekibimizle
                iletişime geçebilirsiniz.
              </p>
            </div>
            <button onClick={() => navigate('/mesajlarim')} className="px-6 py-3 bg-gradient-to-r from-blue-600 to-blue-800 rounded-lg hover:opacity-90 transition-opacity font-medium flex items-center gap-2" data-id="element-277">
              <MessageSquare className="w-5 h-5" data-id="element-278" />
              Destek Ekibine Ulaşın
            </button>
          </div>
        </div>
      </div>
    </div>;
}